<template>
  <div class="dataSummary">
      <div class="top-layout">
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img src="@/assets/home/icon1.png" />
            <div>{{ $t('dataSummary.name1') }}</div>
          </div>
          <div class="right" @click="jumpPath('overviewapplisting',3)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div>
        </div>
        <div class="hs">
          <div>{{ cssl }}</div>
          <div></div>
        </div>
      </div>
      <div class="zw"></div>
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img class="img2" src="@/assets/home/icon2.png" />
            <div>{{ $t('dataSummary.name2') }}</div>
          </div>
          <div class="right" @click="jumpPath('overviewappusers',3)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div>
        </div>
        <div class="hs">
          <div>{{ iotshsl }}</div>
          <div></div>
        </div>
      </div>
      <div class="zw"></div>
      <div class="item-layout">
        <div class="item-content">
          <div class="left">
            <img class="img2" src="@/assets/home/icon3.png" />
            <div>{{ $t('dataSummary.name3') }}</div>
          </div>
          <div class="right" @click="jumpPath('overviewappusers',3)">
            <div>{{ $t('home.name1') }}</div>
            <img src="@/assets/home/right-icon.png" />
          </div>
        </div>
        <div class="hs">
          <div>{{ shsl }}</div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="xzqs">
      <div class="text-select">
        <div class="text">{{ $t('dataSummary.name4') }}</div>
        <div class="select">
          <!-- <el-select v-model="merchantName1" :placeholder="$t('public.name1')" class="select-width">
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
          <el-select class="margin-left10 select-width" v-model="merchantType1" :placeholder="$t('public.name2')">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select> -->
          <el-date-picker
            class="margin-left10"
            v-model="monthValue1"
            type="monthrange"
            :editable="false"
            :clearable="false"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name15')"
            :end-placeholder="$t('public.name16')"
            :picker-options="monthpickoption"
          >
          </el-date-picker>
          <el-button type="primary" size="medium" @click="getOperationLoginlogshow"  style="margin-left:10px;">{{ $t('public.name3') }}</el-button>
        </div>
      </div>
      <div class="echarts-div" id="lineChart1" ref="lineChart1"></div>
    </div>
    <div class="gzqk-gzclqk">
      <div class="gzqk">
        <div class="text-select">
          <div class="text">{{ $t('dataSummary.name5') }}</div>
          <div class="select">
            <el-select
              :key="'merchant-type-' + $i18n.locale"
              class="select-width"
              v-model="merchantType2"
              :placeholder="$t('public.name1')"
              @change="changeType"
            >
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <el-select
              :key="'merchant-page-' + $i18n.locale"
              v-model="merchantName2"
              multiple
              collapse-tags
              :multiple-limit="10"
              :placeholder="$t('dataSummary.name6')"
              class="margin-left10 select-width"
              @change="changeMerchantName2"
            >
              <el-option v-for="(item, index) in tenantOptions" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
            <el-date-picker
              class="margin-left10"
              v-model="monthValue2"
              type="monthrange"
              :editable="false"
              :clearable="false"
              format="yyyy-MM"
              value-format="yyyy-MM"
              :range-separator="$t('public.name9')"
              :start-placeholder="$t('public.name15')"
              :end-placeholder="$t('public.name16')"
              :picker-options="monthpickoption"
              @change="changeMonthValue2"
            >
            </el-date-picker>
            <el-button class="margin-left10" type="primary" size='small' @click="getFunctionpageshow" :loading="loading">{{ $t('public.name3') }}</el-button>
          </div>
        </div>
        <div class="echarts-div" id="lineChart2" ref="lineChart2"></div>
      </div>
      </div>
  </div>
</template>
<script>
import { numberExchange, getSize, getArrListToGroup } from '@/utils/utils.js'
import { operationFirstLine, operationLoginlogshow, functionpageshow, listPageName } from '@/api/home.js'
import { matchesFunctionPageLang } from '@/utils/i18nFormHelpers.js'
import { getStoredLocale } from '@/config/flavor'
export default {
  computed: {
    currentPageLang () {
      const locale = this.lang || this.$i18n.locale || getStoredLocale()
      return locale === 'zh' ? 'zh-CN' : 'en-US'
    },
    typeOptions () {
      return [
        { value: 0, label: this.$t('manage.name116') },
        { value: 1, label: this.$t('manage.name117') },
        { value: 20, label: this.$t('manage.name120') },
        { value: 21, label: this.$t('manage.name121') },
        { value: 22, label: this.$t('manage.name129') },
        { value: 3, label: this.$t('manage.name138') }
      ]
    },
    loginLegendNames () {
      return [
        this.$t('manage.name116'),
        this.$t('manage.name117'),
        this.$t('manage.name120'),
        this.$t('manage.name121'),
        this.$t('manage.name129'),
        this.$t('manage.name138')
      ]
    }
  },
  data() {
    return {
      cssl: 0,
      iotshsl: 0,
      shsl: 0,
      lineChar: null,
      merchantName1: '',
      merchantName2: '',
      merchantName3: '',
      merchantType1: '',
      merchantType2: 0,
      merchantType3: '',
      tenantOptions: [],
      loading: false,
      vehicleNewIotDeviceTrendsData: {
        tenantId: '',
        tenantType: '',
        startTime: '',
        endTime: ''
      },
      vehicleFault: {
        userIds: '',
        pageName: '',
        startTime: '',
        endTime: ''
      },
      merchantNameAll: [],
      functionpageshowXAxis: [],
      functionpageshowYAxis: [],
      legendData: [],
      loginStatusXAxis: [],
      loginStatusYAxis1: [],
      loginStatusYAxis2: [],
      loginStatusYAxis3: [],
      loginStatusYAxis4: [],
      loginStatusYAxis5: [],
      loginStatusYAxis6: [],
      activeName: 'first',
      monthValue1: [],
      monthValue2: [],
      monthValue3: [],
      monthValue4: [],
      minDate: null,
      maxDate: null,
      lang: 'zh',
      cachedFunctionPageShowData: null,
      trendData: {
        date: []
      },
      monthpickoption: {
        disabledDate: time => {
          if (this.minDate !== null && this.maxDate === null) {
            const minMonth = this.minDate.getMonth()
            const lastYear = new Date(this.minDate).setMonth(minMonth - 11)
            const nextYear = new Date(this.minDate).setMonth(minMonth + 11)
            const minTime = this.minDate.getTime()
            const accountNow = this.$tz.accountNow().toDate()
            const nextTime = new Date(accountNow).setMonth(accountNow.getMonth() + 11)
            const lastTime = new Date(accountNow).setMonth(accountNow.getMonth() - 11)
            if (minTime <= nextTime || minTime >= lastTime) {
              return time.valueOf() > accountNow.getTime() || time.valueOf() > nextYear.valueOf() || time.valueOf() < lastYear.valueOf()
            } else {
              return time.valueOf() < lastYear.valueOf() || time.valueOf() > nextYear.valueOf()
            }
          } else {
            const startMonth = this.trendData.date[0]
            const month = new Date(startMonth).getMonth()
            const lastMonth = new Date(startMonth).setMonth(month - 11)
            return this.monthPick(time) || time < lastMonth.valueOf()
          }
        },
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate
          this.maxDate = maxDate
        }
      }
    }
  },
  created() {
    this.initAccountMonthRange()
    window.addEventListener('resize', this.chartResize)
    this.$bus.$on('accountTimeZoneChanged', this.initAccountMonthRange)
  },
  mounted() {
    this.getTopData()
    this.lang = getStoredLocale()
    this.getOperationLoginlogshow()
    this.getFunctionpageshow()
    this.lineChart1 = this.$echarts.init(this.$refs.lineChart1, null, { renderer: 'svg' })
    this.lineChart2 = this.$echarts.init(this.$refs.lineChart2, null, { renderer: 'svg' })
    this.changeType(this.merchantType2)
    this.$bus.$on('lang', this.handleLangChange)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
    this.$bus.$off('lang', this.handleLangChange)
    this.$bus.$off('accountTimeZoneChanged', this.initAccountMonthRange)
  },
  methods: {
    handleLangChange (lang) {
      this.lang = lang
      this.merchantName2 = []
      this.changeType(this.merchantType2)
      this.firstcharts()
      if (this.cachedFunctionPageShowData) {
        this.applyFunctionPageShowData(this.cachedFunctionPageShowData)
      } else {
        this.secondcharts()
      }
    },
    initAccountMonthRange() {
      const [startMonth, endMonth] = this.$tz.defaultMonthRange(12)
      this.monthValue1[0] = startMonth
      this.monthValue1[1] = endMonth
      this.monthValue2[0] = startMonth
      this.monthValue2[1] = endMonth
    },
    getTopData() {
      operationFirstLine()
        .then((res) => {
          this.cssl = numberExchange(res.data.appNum) || 0
          this.iotshsl = numberExchange(res.data.userNum) || 0
          this.shsl = numberExchange(res.data.monthNewUserNum) || 0
        })
        .catch(() => {})
    },
    getOperationLoginlogshow() {
      this.vehicleNewIotDeviceTrendsData = {
        startTime: this.monthValue1[0],
        endTime: this.monthValue1[1]
      }
      operationLoginlogshow(this.vehicleNewIotDeviceTrendsData)
        .then((res) => {
          if (res.code === 200) {
            this.loginStatusXAxis = []
            this.loginStatusYAxis1 = []
            this.loginStatusYAxis2 = []
            this.loginStatusYAxis3 = []
            this.loginStatusYAxis4 = []
            this.loginStatusYAxis5 = []
            this.loginStatusYAxis6 = []
            res.data.map((item) => {
              this.loginStatusXAxis.push(item.month)
              this.loginStatusYAxis1.push(item.num0)
              this.loginStatusYAxis2.push(item.num1)
              this.loginStatusYAxis3.push(item.num20)
              this.loginStatusYAxis4.push(item.num21)
              this.loginStatusYAxis5.push(item.num22)
              this.loginStatusYAxis6.push(item.num3)
            })
            this.firstcharts()
          }
        })
        .catch(() => {})
    },
    changeMonthValue2() {
      this.vehicleFault.startTime = this.monthValue2[0]
      this.vehicleFault.endTime = this.monthValue2[1]
      this.getFunctionpageshow()
    },
    applyFunctionPageShowData (resData) {
      const data = []
      resData.map((item) => {
        if (this.merchantName2.length > 0) {
          this.merchantName2.map((items) => {
            if (item.pageName === items) {
              data.push(item)
            }
          })
        } else {
          data.push(item)
        }
      })
      const data1 = data.filter((item) => matchesFunctionPageLang(item, this.currentPageLang))
      const arr = getArrListToGroup(data1, 'month')
      const arr1 = getArrListToGroup(data1, 'pageName')
      this.functionpageshowYAxis = []
      this.legendData = []
      this.functionpageshowXAxis = []
      arr.map((item) => {
        this.functionpageshowXAxis.push(item.key)
      })
      arr1.map((item) => {
        this.legendData.push(item.key)
        const obj = {}
        obj.name = item.key
        obj.symbolSize = 5
        obj.symbol = 'none'
        obj.type = 'line'
        obj.data = []
        item.data.map((items) => {
          obj.data.push(items.idCount)
        })
        this.functionpageshowYAxis.push(obj)
      })
      this.secondcharts()
    },
    getFunctionpageshow() {
      this.loading = true
      this.functionpageshowYAxis = []
      this.legendData = []
      this.functionpageshowXAxis = []
      this.merchantNameAll = []
      this.vehicleFault = {
        pageName: '',
        tenantType: this.merchantType2,
        startTime: this.monthValue2[0],
        endTime: this.monthValue2[1]
      }
      functionpageshow(this.vehicleFault)
        .then((res) => {
          if (res.code === 200) {
            this.cachedFunctionPageShowData = res.data
            this.applyFunctionPageShowData(res.data)
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    changeMerchantName2 () {
      this.getFunctionpageshow()
    },
    jumpPath(path, index) {
      this.$bus.$emit('clickIndex', path, index)
    },
    monthPick(time) {
      const nowDate = this.$tz.accountNow().format('YYYYMM')
      const elTimeData = this.$moment(time).format('YYYYMM')
      return elTimeData > nowDate
    },
    chartResize() {
      if (this.lineChart1) {
        setTimeout(() => {
          this.lineChart1.resize()
          this.firstcharts()
          this.lineChart2.resize()
          this.secondcharts()
        }, 10)
      }
    },

    async firstcharts() {
      const legendNames = this.loginLegendNames
      const option = {
        // color: ['#42bf7c', '#5a7ff1', '#e4bf55', '#e46f55'],
        grid: {
          left: getSize(20),
          right: getSize(20),
          top: getSize(120),
          bottom: getSize(20),
          containLabel: true
        },
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: function(point, params, dom, rect, size) {
            var x = 0
            var y = 0
            var pointX = point[0]
            var pointY = point[1]
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            if (boxWidth > pointX) {
              x = 5
            } else {
              x = pointX - boxWidth
            }
            if (boxHeight > pointY) {
              y = 5
            } else {
              y = pointY - boxHeight
            }
            return [x, y]
          }
        },
        legend: {
          data: legendNames,
          top: getSize(74)
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false // 不显示坐标轴刻度线
          },
          data: this.loginStatusXAxis
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [
          {
            name: legendNames[0],
            data: this.loginStatusYAxis1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: legendNames[1],
            data: this.loginStatusYAxis2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: legendNames[2],
            data: this.loginStatusYAxis3,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: legendNames[3],
            data: this.loginStatusYAxis4,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: legendNames[4],
            data: this.loginStatusYAxis5,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: legendNames[5],
            data: this.loginStatusYAxis6,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart1.setOption(option)
    },
    changeType(e) {
      this.merchantName2 = []
      this.tenantOptions = []
      // listPageName 可能只返回 pageName 字符串；无 lang 时由 matchesFunctionPageLang 启发式过滤
      listPageName({ tenantType: e })
        .then((res) => {
          const seen = new Set()
          ;(res.data || []).forEach((item) => {
            const record = typeof item === 'string' ? { pageName: item, lang: null } : item
            if (matchesFunctionPageLang(record, this.currentPageLang) && !seen.has(record.pageName)) {
              seen.add(record.pageName)
              this.tenantOptions.push(record.pageName)
            }
          })
        })
        .catch(() => {})
    },
    async secondcharts() {
      const option = {
        grid: {
          left: getSize(20),
          right: getSize(20),
          top: getSize(120),
          bottom: getSize(20),
          containLabel: true
        },
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: function(point, params, dom, rect, size) {
            var x = 0
            var y = 0
            var pointX = point[0]
            var pointY = point[1]
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            if (boxWidth > pointX) {
              x = 5
            } else {
              x = pointX - boxWidth
            }
            if (boxHeight > pointY) {
              y = 5
            } else {
              y = pointY - boxHeight
            }
            return [x, y]
          }
        },
        legend: {
          data: this.legendData,
          top: getSize(74),
          orient: 'horizontal',
          type: 'scroll'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false // 不显示坐标轴刻度线
          },
          data: this.functionpageshowXAxis
        },
        yAxis: {
          type: 'value'
        },
        series: this.functionpageshowYAxis
      }
      this.lineChart2.setOption(option, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.dataSummary {
  .top-layout {
    display: flex;
    justify-content: space-between;
    // flex-direction: row;
    align-items: center;
    min-width: 1200px;
    .zw {
      width: 1.11vw;
      min-width: 20px;
    }

    .item-layout {
      width: 33%;
      height: px2vw(153);
      min-width: 260.5px;
      min-height: 153px;
      border-radius: px2vw(8);
      background: #f5f5f5;
      border: 1px solid #969797;

      .hs {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin-left: px2vw(22);
        > :first-child {
          font-family: PuHuiTi-700;
          font-size: 48px;
          line-height: 65.86px;
          text-align: left;
          color: #555555;
        }
        > :last-child {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: 19.6px;
          margin-left: px2vw(8);
          color: #555555;
        }
      }
      .item-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: px2vw(20);

        .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          .img2 {
            width: 16px;
            height: 16px;
          }
          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #555555;
            margin-left: px2vw(8);
          }
        }

        .right {
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-left: px2vw(4);
          }
          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #8d96a9;
          }
        }
      }
    }
  }

  .gzqk-gzclqk {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);

    .lines {
      width: 1px;
      background: #e5e3ec;
      height: px2vw(360);
      min-height: 360px;
      min-width: 1px;
    }
    .gzqk {
      width: 100%;
      position: relative;
    }

    .gzclqk {
      width: 100%;
      position: relative;
    }
  }

  .xzqs {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    min-width: 1200px;
    min-height: 360px;
    height: px2vw(360);
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .simksyqk {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .text-select {
    display: flex;
    position: absolute;
    left: 0;
    top: 22px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    .text {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 22.4px;
      color: #0c2358;
    }
  }

  .margin-left10 {
    margin-left: 10px;
  }

  .select-width {
    width: 180px;
  }

  .echarts-div {
    width: 100%;
    height: 100%;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }
}
</style>
